import { useTranslation } from 'react-i18next'

import { Card, CardTitle } from '@reveni-io/reveni-ui'

import LogisticInfo from './LogisticInfo/LogisticInfo'
import { parcelInfoCardVariants } from './constants'
import * as Styles from './styles'

const ParcelInfoCard = ({
  parcelType,
  senderAddress,
  senderName,
  recipientAddress,
  destinationAddress,
  customerEmail,
  shippingMethod,
  carrierName,
  carrierLogo,
  isPickupPoint,
  onEditOutboundOriginLocation,
  allowEditOutboundOriginLocation,
  onEditOutboundDestinationAddress,
  allowEditOutboundDestinationAddress,
  onSendEmailToCustomer,
  onSendEmailToCarrier,
  allowSendEmail,
  onEditCarrierService,
  allowEditCarrierService,
  onEditInboundOriginAddress,
  allowEditInboundOriginAddress,
  onEditInboundDestinationLocation,
  allowEditInboundDestinationLocation,
}) => {
  const { t } = useTranslation()

  const variant = parcelInfoCardVariants[parcelType]

  if (!variant) return null

  const { ParcelInfoSections, hasManagedLogistics } = variant

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Detalles del envío')}</CardTitle>
      <Styles.MainContainer>
        <ParcelInfoSections
          senderAddress={senderAddress}
          senderName={senderName}
          recipientAddress={recipientAddress}
          destinationAddress={destinationAddress}
          customerEmail={customerEmail}
          onEditOutboundOriginLocation={onEditOutboundOriginLocation}
          allowEditOutboundOriginLocation={allowEditOutboundOriginLocation}
          onEditOutboundDestinationAddress={onEditOutboundDestinationAddress}
          allowEditOutboundDestinationAddress={allowEditOutboundDestinationAddress}
          onEditInboundOriginAddress={onEditInboundOriginAddress}
          allowEditInboundOriginAddress={allowEditInboundOriginAddress}
          onEditInboundDestinationLocation={onEditInboundDestinationLocation}
          allowEditInboundDestinationLocation={allowEditInboundDestinationLocation}
          onSendEmailToCustomer={onSendEmailToCustomer}
          allowSendEmail={allowSendEmail}
        />
        <LogisticInfo
          shippingMethod={shippingMethod}
          carrierName={carrierName}
          carrierLogo={carrierLogo}
          isPickupPoint={isPickupPoint}
          showShippingMethod={hasManagedLogistics}
          onSendEmailToCarrier={onSendEmailToCarrier}
          allowSendEmail={hasManagedLogistics && allowSendEmail}
          onEditCarrierService={onEditCarrierService}
          allowEditCarrierService={allowEditCarrierService}
        />
      </Styles.MainContainer>
    </Card>
  )
}

export default ParcelInfoCard
